import renderViewer, { RenderViewerParams } from './viewer'
;(window as any).renderViewer = (params: RenderViewerParams) => {
  renderViewer(params)
}
